// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1XTGE","header":"ReportDetails_header__2Pk3b","title":"ReportDetails_title__3hxkX","left":"ReportDetails_left__1P1hE"};